"use client"

import { selectIsForgotPassModalOpen } from "features/common/model/selectors/appSelectors"
import { setIsAuthModalOpen, setIsForgotPassModalOpen } from "features/common/model/slice/appSlice"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { Button, Form, FormProps, Input, Modal, Typography } from "shared/ui"
import styled from "styled-components"

import { ressetPasswordThunk } from "../model/slice/userSlice"

type FieldType = {
  login: string
}

export const ForgotPassModal = () => {
  const dispatch = useAppDispatch()
  const isForgotPassModalOpen = useAppSelector(selectIsForgotPassModalOpen)
  const { Title } = Typography

  const handleFinish: FormProps<FieldType>['onFinish'] = (values) => {
    const successCallback = () => {
      handleOpenAuthModal()
    }
  
    dispatch(ressetPasswordThunk({ login: values.login, successCallback }))
  }

  const handleOpenAuthModal = () => {
    dispatch(setIsForgotPassModalOpen(false))
    dispatch(setIsAuthModalOpen(true))
  }
  
  const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  return (    
    <Modal open={isForgotPassModalOpen}
      footer={null}
      width={480}
      centered
      closable={false}
      destroyOnClose={true}
      styles={{ mask: { backgroundColor: "transparent" } }}
      wrapClassName="forgot-pass-modal-wrapper"
    >
      <SModalTitle>
        <Title>
          Resset password
        </Title>
      </SModalTitle>

      <SContentContainer>
        <Form layout="vertical"
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          preserve={false}
          requiredMark="optional"
        >
          <Form.Item name="login"
            label="Email Address"
            rules={[{ required: true, message: "Enter email" }, { type: "email", message: "Enter a valid email" }]}
          >
            <Input size="large"
              placeholder="Valid email address"
            />
          </Form.Item>

          <Form.Item>
            <Button block
              type="primary"
              htmlType="submit"
            >
              Resset password
            </Button>
          </Form.Item>
        </Form>

        <SModalButtomText>
          <span>
            Remembered?
          </span>

          <Button type="link"
            style={{ paddingInline: 1, color: '#6532B8' }}
            onClick={handleOpenAuthModal}
          >
            Sign in
          </Button>
        </SModalButtomText>
      </SContentContainer>
    </Modal>
  )
}

const SContentContainer = styled.div``

const SModalTitle = styled.div`
  text-align: center
`
const SModalButtomText = styled.div`
  text-align: center
`

